export enum SuggestionsTrigger {
  DeclineWithReason = 'decline_with_reason',
  DeclineWithoutReason = 'decline_without_reason',
  IgnoreInvite = 'ignore_invite',
  ExitDeclineChat = 'exit_decline_chat',
  ExitAfterApplication = 'exit_after_application',
}
